import React, { useEffect,useState } from 'react';
import '../styles/HeroSection.css';
import ContactForm from "./ContactForm"; // ⬅ Import new component
import "../styles/ContactUs.css";
import { Helmet ,HelmetProvider} from "react-helmet-async";

const HeroSection = () => {
  const [showForm, setShowForm] = useState(false);
  useEffect(() => {
  window.scrollTo(0, 0);
  // Animation for the rocket
    const animateRocket = () => {
      const rocketElement = document.querySelector('.rocket');
      if (rocketElement) {
      rocketElement.style.transform = "none"; // Reset transform
      rocketElement.classList.remove('animate-rocket');
      void rocketElement.offsetWidth; // Force reflow
      rocketElement.classList.add('animate-rocket');
      }
    };

    // Initial animation
    setTimeout(animateRocket, 500);

  }, []);

  return (
    <>
    <HelmetProvider>
      <Helmet>
      <title>INBI NextGen Innovations– Innovating Today, Shaping Tomorrow</title>
      <meta
        name="description"
        content="Welcome to INBI NextGen Innovations Private Limited. We create cutting-edge software solutions, IoT platforms, and ERP systems that transform businesses and simplify lives."
      />
      <meta name="keywords" content="INBI NextGen Innovations, software solutions, IoT, ERP systems, custom software, digital transformation India" />

      {/* Open Graph */}
      <meta property="og:title" content="INBI NextGen Innovations Private Limited"/>
      <meta property="og:description" content="Innovating Today. Shaping Tomorrow."/>
      <meta property="og:image" content="/assets/Logoblue.jpg" />
      
      <meta property="og:url" content="https://inbinextgen.com/#hero" />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="INBI NextGen Innovations" />

      {/* Twitter */}
      
      <meta name="twitter:title" content="INBI NextGen Innovations Private Limited"/>
      <meta name="twitter:description" content="Innovating Today. Shaping Tomorrow."/>
      <meta name="twitter:image" content="/assets/Logoblue.jpg" />
      
    </Helmet>
    </HelmetProvider>
    

    <section id="home" className="hero-section reveal">
      <div className="hero-content">

        <div className="hero-text">
          <div>
            Welcome to{" "}
            <h1 style={{ display: "inline", margin: 0 }}>
              INBI NextGen Innovations Private Limited
            </h1>
          </div>
          <h2>Inventions</h2>
          <h2>Beyond</h2>
          <h2>Imagination</h2>
          <p>
            We create cutting-edge software solutions that transform businesses and simplify lives.
          </p>
          <div className="hero-buttons">
            <a href="#services" className="btn primary-btn">
              Explore Our Services
            </a>
            <button className="btn secondary-btn" onClick={() => setShowForm(true)}>
            Get in Touch
          </button>
          </div>
        </div>

        <div className="hero-images">
          <div className="cloud-container">
            <img src="/assets/cloud.svg" alt="Innovation and Technology at INBI NextGen Innovations" className="cloud" />
            <img src="/assets/rocket.png" alt="INBI NextGen Innovations " className="rocket" />
          </div>
        </div>
      </div>
      {/* Modal Form Component */}
      {showForm && <ContactForm onClose={() => setShowForm(false)} />}
    </section>
    </>
  );
};
export default HeroSection;